import { Menu } from 'antd';
import Title from 'antd/es/typography/Title';
import { SweetSweetAlert } from 'component/sweetalert_components';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { checkLicense, getLicenseDetails, setTrialExpired } from 'redux/slices/licenseSlice';
import { AdminNavWrap } from './style';

export default function AdminNavBar() {
  const { licenseDetails } = useSelector((state) => state.licenseSlice);
  const [activeMenuItem, setActiveMenuItem] = useState('adminpage');
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const CheckProductLicense = async () => {
      if (
        /\/adminpage|email_template|create_domain|settings|license|themes|email_delivery|endpoints|brandings|api_settings/.test(
          location.pathname
        )
      ) {
        const checkLicenseStatus = await dispatch(checkLicense());
        if (checkLicenseStatus?.payload.data === 'License mismatch') {
          SweetSweetAlert({ text: checkLicenseStatus.payload.data, icon: 'error', buttonColor: 'red' });
          navigate('/license');
        } else if (checkLicenseStatus?.payload.data === 'The trial license has expired.') {
          dispatch(setTrialExpired(checkLicenseStatus.payload.data));
          navigate('/license');
        }
      }
    };
    CheckProductLicense();
  }, [location.pathname]);

  useEffect(() => {
    dispatch(getLicenseDetails());
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname === '/adminpage') {
      setActiveMenuItem('adminpage');
    } else if (location.pathname === '/email_template') {
      setActiveMenuItem('email_template');
    } else if (location.pathname === '/email_delivery') {
      setActiveMenuItem('email_delivery');
    } else if (location.pathname === '/settings') {
      setActiveMenuItem('settings');
    } else if (location.pathname === '/endpoints') {
      setActiveMenuItem('endpoints');
    } else if (location.pathname === '/license') {
      setActiveMenuItem('license');
    } else if (location.pathname === '/brandings') {
      setActiveMenuItem('brandings');
    } else if (location.pathname === '/api_settings') {
      setActiveMenuItem('api_settings');
    } else if (location.pathname === '/themes' || location.pathname === '/customize_theme') {
      setActiveMenuItem('themes');
    }
  }, [location.pathname]);

  return (
    <div>
      <AdminNavWrap className='af-admin-navbar-wrap'>
        <Title level={3} style={{ margin: '0px 20px 0px' }} className='af-admin-navbar-title'>
          Administrator
        </Title>
        <Menu
          mode='vertical'
          selectedKeys={[activeMenuItem]}
          style={{ marginTop: '10px', fontSize: '15px', backgroundColor: 'inherit' }}
          className='af-admin-navbar-menu-wrap'
        >
          {licenseDetails?.isActived && (
            <>
              <Menu.Item key='adminpage' className='af-admin-navbar-menu-item-domain'>
                <Link to='/adminpage' className='af-admin-navbar-link-domain'>
                  Domains
                </Link>
              </Menu.Item>
              <Menu.Item key='settings' className='af-admin-navbar-menu-item-setting'>
                <Link to='/settings' className='af-admin-navbar-link-setting'>
                  Settings
                </Link>
              </Menu.Item>
              <Menu.Item key='themes' className='af-admin-navbar-menu-item-theme'>
                <Link to='/themes' className='af-admin-navbar-menu-item-theme'>
                  Themes
                </Link>
              </Menu.Item>
              <Menu.Item key='brandings' className='af-admin-navbar-menu-item-branding'>
                <Link to='/brandings' className='af-admin-navbar-link-branding'>
                  Brandings
                </Link>
              </Menu.Item>
              <Menu.Item key='email_template' className='af-admin-navbar-menu-item-template'>
                <Link to='/email_template' className='af-admin-navbar-link-template'>
                  Email Templates
                </Link>
              </Menu.Item>
              <Menu.Item key='email_delivery' className='af-admin-navbar-menu-item-delivery'>
                <Link to='/email_delivery' className='af-admin-navbar-link-delivery'>
                  Email Delivery
                </Link>
              </Menu.Item>
            </>
          )}
          {licenseDetails?.isActived && (
            <>
              <Menu.Item key='endpoints' className='af-admin-navbar-menu-item-endpoint'>
                <Link to='/endpoints' className='af-admin-navbar-link-endpoint'>
                  Endpoints
                </Link>
              </Menu.Item>
              <Menu.Item key='api_settings' className='af-admin-navbar-menu-item-api'>
                <Link to='/api_settings' className='af-admin-navbar-link-api'>
                  API Settings
                </Link>
              </Menu.Item>
            </>
          )}
          <Menu.Item key='license' className='af-admin-navbar-menu-item-activation'>
            <Link to='/license' className='af-admin-navbar-link-activation'>
              Activation
            </Link>
          </Menu.Item>
        </Menu>
      </AdminNavWrap>
    </div>
  );
}
